<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4.6875C0 2.09867 2.09867 0 4.6875 0H40.3125C42.9013 0 45 2.09867 45 4.6875V40.3125C45 42.9013 42.9013 45 40.3125 45H4.6875C2.09867 45 0 42.9013 0 40.3125V4.6875Z"
      fill="#007AFF"
    />
    <path
      d="M16.1587 25.1257C21.2511 25.1257 24.8924 22.0319 25.1252 17.3365H20.2928C19.978 19.65 18.3763 21.1011 16.1723 21.1011C13.4072 21.1011 11.6823 18.7602 11.6823 14.8861C11.6823 11.0532 13.4209 8.71226 16.1587 8.71226C18.3626 8.71226 20.0191 10.2455 20.2655 12.5727H25.0978C24.9472 7.9046 21.1553 4.68762 16.1587 4.68762C10.2723 4.68762 6.5625 8.45218 6.5625 14.8998C6.5625 21.3612 10.2449 25.1257 16.1587 25.1257Z"
      fill="white"
    />
    <path
      d="M33.7058 24.5499H39.0448L32.4055 4.79633H26.259L19.6196 24.5499H24.7394L25.9988 20.2105H32.4602L33.7058 24.5499ZM29.1747 8.98523H29.2843L31.4745 16.5964H26.9708L29.1747 8.98523Z"
      fill="white"
    />
    <path
      d="M11.79 23.7274H14.7195C16.5129 23.7274 17.6765 24.8635 17.6765 26.5474C17.6765 28.2586 16.5813 29.34 14.7332 29.34H11.79V23.7274ZM11.79 32.7761H14.35L17.7449 39.689H23.3849L19.4287 32.0368C21.5916 31.0923 22.81 28.8745 22.81 26.4515C22.81 22.3721 20.1542 19.9355 15.2261 19.9355H6.76611V39.689H11.79V32.7761Z"
      fill="white"
    />
    <path
      d="M22.5835 19.9355V39.689H30.6055C36.5603 39.689 40.0785 36.0067 40.0785 29.6959C40.0785 23.3988 36.5741 19.9355 30.6055 19.9355H22.5835ZM27.6075 23.9875H29.9483C33.1243 23.9875 34.9723 25.9998 34.9723 29.7097C34.9723 33.6521 33.2201 35.6371 29.9483 35.6371H27.6075V23.9875Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
